<template>
	<!-- 头部整体盒子 -->
	<div id="header" class="container-fuild">
		<!-- 电脑导航 -->
		<div class="header-nav container hidden-xs">
			<!-- 导航logo -->
			<div class="header-nav-logo hidden-sm">
        <h2 style="margin: 0;" class="">THE LOGO</h2>
				<!-- <img src="@/assets/img/logo_black.png"> -->
			</div>
			<!-- 导航内容 -->
			<ul class="header-nav-wrapper">
				<li v-for="(item,index) in navList" :key="index" :class="index==navIndex?'active':''"
					@click="navClick(index,item.name)">
					<router-link :to="item.path">
						{{item.name}}<br><small>{{item.en}}</small>
						<span v-if="item.children.length>0" class="glyphicon glyphicon-menu-right"></span>
						<!-- <i class="underline"></i> -->
					</router-link>
					<dl v-if="item.children.length>0">
						<div class="container">
							<dt v-for="(i,n) in item.children" :key="n">
								<div :class="i.children&&i.children.length>0?'':''">
									<!-- border-bottom -->
									<router-link :to="i.path" style="color: #FFF;font-size: 16px;">{{i.name}}
									</router-link>
								</div>
								<div v-if="i.children&&i.children.length>0" class="three-menu">
									<div class="container"></div>
									<div v-for="(ic,nc) in i.children" :key="nc" @click="onAddRole(ic.path,nc)">
										<span style="color: #FFF;font-size: 16px;">{{ic.name}}</span>
										<!-- <span @click="onAddRole">{{ic.name}}</span> -->
									</div>
								</div>
							</dt>
						</div>
					</dl>
				</li>
			</ul>
		</div>
		<!-- 手机导航 -->
		<div class="header-nav-m container-fuild visible-xs"><!--  :class="scrollTop>50?'scrollTopflex':''" -->
			<!-- <div class="header-nav-m-logo">
				<img class="center-block" src="@/assets/img/logo_black.png" alt="logo">
			</div> -->
			<!-- 导航栏 -->
			<div class="header-nav-m-menu text-center">
				<div data-toggle="collapse" data-target="#menu" @click="menuClick">
					{{menuName}}
					<div class="header-nav-m-menu-wrapper" data-toggle="collapse" data-target="#menu"
						@click="menuClick">
						<span :class="menuClass"></span>
					</div>
				</div>
				<!-- 导航内容 -->
				<ul id="menu" class="header-nav-m-wrapper collapse">
					<li v-for="(item,index) in navList" :key="index" :class="[index==navIndex?'active':'']">
						<div @click="menuClick2(index,item.children.length)">
							<span v-if="item.children.length>0">{{item.name}}</span>
							<span v-else @click="navClick(index,item.name)" data-toggle="collapse" data-target="#menu">
								<router-link :to="item.path" style="color: #FFF;">
									{{item.name}}
								</router-link>
							</span>
							<i v-if="item.children.length>0" class="header-nav-m-menu-wrapper"><span
									:class="twoMenu == index?menuClass2:'glyphicon glyphicon-menu-down'"></span></i>
						</div>
						<ul v-if="item.children.length>0" v-show="twoMenu == index">
							<li v-for="(i,n) in item.children" :key="n" :class="index==navIndex?'active':''">
								<span @click="navClick(n,i.name)" data-toggle="collapse" data-target="#menu">
									<router-link :to="i.path">
										{{i.name}}
										<i class="underline"></i>
									</router-link>
								</span>
							</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
		<!-- 用于手机上划固定菜单时填空空位，避免抖动 -->
		<!-- <div class=" visible-xs" style="height: 50px;" v-if="scrollTop>50"></div> -->
	</div>
</template>
<script>
	export default {
		name: "Header",
		data() {
			return {
				navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
				menuName: "首页",
				menuClass: "glyphicon glyphicon-menu-down",
				menuClass2: "glyphicon glyphicon-menu-down",
				scrollTop: 0,
				twoMenu: '',
				navList: [{
						name: "首页",
            en:"home",
						path: "/",
						children: []
					},
					{
						name: "宗亲文化",
            en:"Culture",
						path: "/Culture", ///software
						children: []
					},
					{
						name: "云平台",
            en:"Cloud",
						path: "/Cloud",
						children: [
							// {
							// 	name: "生命大数据平台",
							// 	path: "/BigLife",
							// 	children: [{
							// 			name: "真实世界研究支持",
							// 			path: "/BigLife/World"
							// 		},
							// 		{
							// 			name: "医药市场数据支持 ",
							// 			path: "/BigLife/Medicine"
							// 		},
							// 		{
							// 			name: "保险业务支持 ",
							// 			path: "/BigLife/Insurance"
							// 		}
							// 	]
							// },
						]
					},
					{
						name: "家谷动态",
            en:"dynamic",
						path: "/dynamic",
						children: []
					},
					{
						name: "关于我们",
            en:"About",
						path: "/About",
						children: []
					},
          {
          	name: "招贤纳士",
            en:"recruit",
          	path: "/recruit",
          	children: []
          },
          {
          	name: "招商谷",
            en:"attract",
          	path: "/attract",
          	children: []
          }
				]
			};
		},
		mounted() {
      this.menuName = this.navList[this.navIndex].name
			window.addEventListener('scroll', this.handleScroll)
			console.log(sessionStorage.getItem('navIndex'));
			this.navIndex = sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0;
		},
		methods: {
			navClick(index, name) {
				this.navIndex = index;
				sessionStorage.setItem('navIndex', index)
				this.menuName = name;
				this.menuClass = "glyphicon glyphicon-menu-down";
			},
			menuClick(e) {
				if (this.menuClass == "glyphicon glyphicon-menu-down") {
					this.menuClass = "glyphicon glyphicon-menu-up";
				} else {
					this.menuClass = "glyphicon glyphicon-menu-down";
				}
			},
			menuClick2(index, length) {
				if (length != 0) {
					if (this.twoMenu == index) {
						this.twoMenu = '';
					} else {
						this.twoMenu = index;
					}
				}
				if (this.menuClass2 == "glyphicon glyphicon-menu-down") {
					this.menuClass2 = "glyphicon glyphicon-menu-up";
				} else {
					this.menuClass2 = "glyphicon glyphicon-menu-down";
				}
			},
			handleScroll() {
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.boby.scrollTop;
				this.scrollTop = scrollTop;
			},
			onAddRole(path, index) {
				console.log(path);
				this.$router.push({
					path: path, //.substring(0,path.lastIndexOf("/")),
					query: {
						path: index,
						t: new Date().getTime()
					}
				})
			}
		}
	};
</script>
<style scoped>
	.scrollTopflex {
		position: fixed !important;
		top: 0;
		width: 100%;
		z-index: 9999;
		background-color: #f4f4f4;
	}

	.border-bottom {
		border-bottom: 2px solid #C0C0C0;
		padding-bottom: 20px;
		margin-bottom: 20px;
	}

	/* 顶部 */
	#header {
		background: rgba(255,255,255,0.1);
		position: fixed;
    z-index: 9;
    width: 100%;
    padding: 10px 0;
	}

	#header .header-top {
		height: 50px;
		color: #fff;
		font-size: 12px;
		line-height: 50px;
		background: #474747;
	}

	/* 顶部的图标 */
	#header .header-top span {
		margin: 0 8px;
	}

	/* 导航栏 */
	#header .header-nav {
		height: 70px;
		position: relative;
    background-color: #f6e2d0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 20px;
	}

	/* 导航栏logo */
	#header .header-nav .header-nav-logo {
		width: 200px;
		height: 100%;
    display: flex;
    align-items: center;
	/* 	float: left;
		position: relative; */
	}

	/* 导航栏logo图片 */
	#header .header-nav .header-nav-logo img {
		width: 195px;
		height: 35px;
		/* position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		margin: auto; */
	}

	/* 导航栏 导航容器 */
	#header .header-nav-fixed .header-nav-wrapper {
		/* line-height: 50px; */
	}

	#header .header-nav .header-nav-wrapper {
		/* line-height: 70px; */
		/* float: right; */
		margin: 0;
		/* max-width: 800px; */
		/* position: absolute;
		bottom: 13px;
		right: 0;
		width: 100%; */
		align: right;
		display: flex;
		justify-content: flex-end;
	}

	/* 导航栏 每个导航 */
	#header .header-nav .header-nav-wrapper>li {
		float: left;
		margin: 0 25px;
		/* position: relative; */
	}

	/* 导航栏 每个导航下面的 a 链接 */
	#header .header-nav .header-nav-wrapper>li>a {
		color: #000;
		font-size: 15px;
		font-weight: bold;
		padding: 15px 0;
		position: relative;
	}

	/* 导航栏 每个导航下面的 a 链接的下划线 */
	#header .header-nav .header-nav-wrapper>li>a>i {
		display: block;
		position: absolute;
		bottom: -2px;
		left: 50%;
		width: 0;
		height: 2px;
		opacity: 0;
		transition: all 0.6s ease;
		background-color: #1e73be;
	}

	/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
	#header .header-nav .header-nav-wrapper>li>a>span {
		font-size: 12px;
		transition: transform ease 0.5s;
	}

	/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
	#header .header-nav .header-nav-wrapper>li>a:hover {
		color: #1e73be;
		text-decoration: none;
	}

	/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
	#header .header-nav .header-nav-wrapper>li>a:hover .underline {
		opacity: 1;
		width: 100%;
		left: 0;
	}

	/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
	#header .header-nav .header-nav-wrapper>li>a:hover span {
		transform: rotate(90deg);
	}

	/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
	#header .header-nav .header-nav-wrapper>li.active>a {
		color: #3dbde9;
		text-decoration: none;
		/* border-bottom: 4px solid #3dbde9; */
		z-index: 9;
	}

	/* 导航栏 每个导航下面的二级导航容器 */
	#header .header-nav .header-nav-wrapper>li>dl {
		display: none;
		position: absolute;
		width: 100%;
		top: 36px;
		left: 0;
		z-index: 999999;
	}

	/* 导航栏 每个导航下面的二级导航容器的每个导航 */
	#header .header-nav .header-nav-wrapper>li>dl>div>dt {
		width: 100%;
		padding: 10px;
		/* border-bottom: 1px solid #ccc; */
	}

	/* 导航栏 每个导航下面的二级导航容器的每个导航内容居中，*/
	#header .header-nav .header-nav-wrapper>li>dl>div>dt {
		text-align: center;
		max-width: 20%;
	}

	/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
	#header .header-nav .header-nav-wrapper>li>dl>div>dt a:hover {
		text-decoration: none !important;
		color: #000000 !important;
		font-weight: 600;
	}

	#header .header-nav .header-nav-wrapper>li>dl>div {
		display: flex;
		position: relative;
		box-shadow: 0 0 3px 1px #ccc;
		background: rgba(61, 189, 233, 0.3);
		padding: 20px 0;
	}

	/* 导航栏 滑上一级导航显示二级导航 */
	#header .header-nav .header-nav-wrapper>li:hover dl {
		display: flex;
	}

	#header .header-nav .header-nav-wrapper>li>dl>div>dt:hover {
		cursor: pointer;
		color: #000000 !important;
	}

	.three-menu {
		margin-top: 42px;
		display: none;
	}

	#header .header-nav .header-nav-wrapper>li>dl>div>dt:hover .three-menu {
		display: block;
	}

	.three-menu .container {
		border-top: 2px solid #E7E7E7;
		position: absolute;
		left: 0;
		margin-top: -20px;
	}

	.three-menu span {
		display: inline-block;
		padding-top: 10px;
	}

	.three-menu span:hover {
		color: #000000 !important;
		text-decoration: none !important;
		font-weight: 600;
	}

	@media screen and (max-width: 997px) {
    #header{
      position: relative;
      padding: 0;
    }
		#header .header-nav-m {
			position: relative;
		}

		/* 导航栏logo容器 */
		#header .header-nav-m .header-nav-m-logo {
			height: 70px;
			position: relative;
		}

		/* 导航栏logo图片 */
		#header .header-nav-m .header-nav-m-logo img {
			width: 195px;
			height: 35px;
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			margin: auto;
		}

		/* 导航栏  菜单容器 */
		#header .header-nav-m .header-nav-m-menu {
			color: #fff;
			height: 50px;
			font-size: 20px;
			line-height: 50px;
			background: #474747;
			position: relative;
		}

		/* 导航栏 菜单图标 */
		#header .header-nav-m .header-nav-m-menu-wrapper {
			position: absolute;
			top: 0;
			right: 20px;
			/* margin-top: -20px; */
			width: 50px;
			height: 40px;
			color: #fff;
			z-index: 999999;
			font-size: 12px;
		}

		/* 导航栏 */
		#header .header-nav-m .header-nav-m-wrapper {
			position: absolute;
			top: 50px;
			left: 0;
			width: 100%;
			background: #474747;
			z-index: 9999999;
		}

		/* 导航栏 每个导航 */
		#header .header-nav-m .header-nav-m-wrapper>li {
			/* height: 40px; */
			line-height: 40px;
			border-bottom: 1px solid #ccc;
			position: relative;
		}

		/* 导航栏 每个导航下面的 a 链接 */
		#header .header-nav-m .header-nav-m-wrapper>li>a {
			color: #fff;
			font-size: 15px;
			font-weight: bold;
			padding: 15px 0;
			position: relative;
		}

		/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
		#header .header-nav .header-nav-wrapper>li>a>span {
			font-size: 10px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue